import { z } from 'zod';
import { isoDateTimeSchema } from './common.ts';

/** One raw workflow history event, summarised for display. */
export const historyEventSchema = z.object({
  eventId: z.string(),
  at: isoDateTimeSchema,
  type: z.string(),
  summary: z.string(),
});
export type HistoryEvent = z.infer<typeof historyEventSchema>;

export const historyResponseSchema = z.object({
  events: z.array(historyEventSchema),
});
export type HistoryResponse = z.infer<typeof historyResponseSchema>;
